export const AUTH_EVENTS = {
  LOGIN_SUCCESS: 'login_success',
  LOGIN_FAILED: 'login_failed',
  LOGOUT: 'logout',
  SESSION_EXPIRED: 'session_expired',
};

export const FILTER_EVENTS = {
  FILTER_CHANGED: 'filter_changed',
  DATE_RANGE_CHANGED: 'date_range_changed',
};

export const DATA_EVENTS = {
  EXCEL_DOWNLOADED: 'excel_downloaded',
  CHART_VIEWED: 'chart_viewed',
};

export const SESSION_VIEWER_EVENTS = {
  PAGE_VIEWED: 'session_viewer_page_viewed',
  FILTER_CHANGED: 'session_filter_changed',
  FILTER_VALUE_COPIED: 'session_filter_value_copied',
  TABLE_DOWNLOADED: 'session_table_downloaded',
  CHART_DOWNLOADED: 'session_chart_downloaded',
  URL_COPIED: 'session_url_copied',
  NO_DATA_DISPLAYED: 'session_no_data_displayed',
  
  // ⚠️ Following events require modifications to @infilect_developer/shelf-visualiser package
  // TAB_CHANGED: 'session_tab_changed',
  // CHECKBOX_TOGGLED: 'session_checkbox_toggled',
  // CANVAS_ZOOMED: 'session_canvas_zoomed',
  // CANVAS_RESET: 'session_canvas_reset',
  // MINIMAP_CLICKED: 'session_minimap_clicked',
  // TABLE_SORTED: 'session_table_sorted',
  // TABLE_SEARCHED: 'session_table_searched',
  // TABLE_ROW_CLICKED: 'session_table_row_clicked',
  // DETECTION_CLICKED: 'session_detection_clicked',
};

export const SESSION_IMAGES_EVENTS = {
  PAGE_VIEWED: 'session_images_page_viewed',
  FILTER_CHANGED: 'session_images_filter_changed',
  IMAGE_OPENED: 'session_images_image_opened',
  SINGLE_IMAGE_DOWNLOADED: 'session_images_single_image_downloaded',
  DOWNLOAD_IMAGES_CLICKED: 'session_images_download_images_clicked',
  VIEW_IN_SEAM_CLICKED: 'session_images_view_in_seam_clicked',
  BULK_MODAL_OPENED: 'session_images_bulk_modal_opened',
  BULK_DATE_RANGE_CHANGED: 'session_images_bulk_date_range_changed',
  BULK_STORE_TOGGLED: 'session_images_bulk_store_toggled',
  BULK_SELECT_ALL_STORES: 'session_images_bulk_select_all_stores',
  BULK_OPTION_TOGGLED: 'session_images_bulk_option_toggled',
  BULK_ALL_OPTIONS_TOGGLED: 'session_images_bulk_all_options_toggled',
  BULK_DOWNLOAD_EXECUTED: 'session_images_bulk_download_executed',
  BULK_MODAL_CLOSED: 'session_images_bulk_modal_closed',
  DOWNLOAD_NOTIFICATION: 'session_images_download_notification',
};

export const DQS_EVENTS = {
  PAGE_VIEWED: 'dqs_page_viewed',
  FILTER_CHANGED: 'dqs_filter_changed',
  SAVE_CORRECTIONS_CLICKED: 'dqs_save_corrections_clicked',
  FIX_PRODUCT_FACING_SUBMITTED: 'dqs_fix_product_facing_submitted',
  SURVEY_SUBMITTED: 'dqs_survey_submitted',
  NEW_PATTERN_SUBMITTED: 'dqs_new_pattern_submitted',
  PATTERN_EXISTENCE_CHECKED: 'dqs_pattern_existence_checked',
  NO_DATA_DISPLAYED: 'dqs_no_data_displayed',
  
  // ⚠️ Following events require modifications to @infilect_developer/shelf-visualiser package
  // TAB_CHANGED: 'dqs_tab_changed',
  // VIEW_INFO_TOGGLED: 'dqs_view_info_toggled',
  // MODE_TOGGLED: 'dqs_mode_toggled',
  // ACCEPT_REJECT_TOGGLED: 'dqs_accept_reject_toggled',
  // CHECKBOX_TOGGLED: 'dqs_checkbox_toggled',
  // CANVAS_ZOOMED: 'dqs_canvas_zoomed',
  // CANVAS_RESET: 'dqs_canvas_reset',
  // MINIMAP_CLICKED: 'dqs_minimap_clicked',
  // TABLE_SORTED: 'dqs_table_sorted',
  // TABLE_SEARCHED: 'dqs_table_searched',
  // TABLE_ROW_CLICKED: 'dqs_table_row_clicked',
  // DETECTION_CLICKED: 'dqs_detection_clicked',
  // URL_COPIED: 'dqs_url_copied',
};

export const INFISUITE_EVENTS = {
  PAGE_VIEWED: 'infisuite_page_viewed',
  TOOL_CLICKED: 'infisuite_tool_clicked',
  MENU_ITEM_SELECTED: 'infisuite_menu_item_selected',
};

export const HQ_ANALYTICS_EVENTS = {
  PAGE_VIEWED: 'hq_analytics_page_viewed',
  TABLEAU_OPENED: 'hq_analytics_tableau_opened',
  REPORT_LOADED: 'hq_analytics_report_loaded',
  DATA_SELECTED: 'hq_analytics_data_selected',
  BUTTON_CLICKED: 'hq_analytics_button_clicked',
  REPORT_ERROR: 'hq_analytics_report_error',
};

export const HEADER_EVENTS = {
  NAV_CLICKED: 'header_nav_clicked',
  HOME_CLICKED: 'header_home_clicked',
  PROFILE_MENU_OPENED: 'header_profile_menu_opened',
  PROFILE_ACTION: 'header_profile_action',
};

export const SIDEBAR_EVENTS = {
  ITEM_CLICKED: 'sidebar_item_clicked',
  FILTER_CHANGED: 'sidebar_filter_changed',
};

export const LOGIN_PAGE_EVENTS = {
  CLIENT_SUBMITTED: 'login_client_submitted',
  LOGIN_SUBMITTED: 'login_submitted',
  SSO_CLICKED: 'login_sso_clicked',
  GOOGLE_AUTH_CLICKED: 'login_google_auth_clicked',
  MICROSOFT_AUTH_CLICKED: 'login_microsoft_auth_clicked',
  FORGOT_PASSWORD_CLICKED: 'login_forgot_password_clicked',
  FORGOT_PASSWORD_SUBMITTED: 'login_forgot_password_submitted',
  RESET_PASSWORD_SUBMITTED: 'login_reset_password_submitted',
  VERIFY_PASSWORD_SUBMITTED: 'login_verify_password_submitted',
};

export const STORE_EXPLORER_EVENTS = {
  PAGE_VIEWED: 'store_explorer_page_viewed',
  FILTER_CHANGED: 'store_explorer_filter_changed',
  GRANULARITY_CHANGED: 'store_explorer_granularity_changed',
  CHART_PINNED: 'store_explorer_chart_pinned',
  EXCEL_DOWNLOADED: 'store_explorer_excel_downloaded',
  SLICER_CHANGED: 'store_explorer_slicer_changed',
};

export const SURVEY_EVENTS = {
  PAGE_VIEWED: 'survey_page_viewed',
  FILTER_CHANGED: 'survey_filter_changed',
  IMAGE_OPENED: 'survey_image_opened',
  DOWNLOAD_EXECUTED: 'survey_download_executed',
  BULK_MODAL_OPENED: 'survey_bulk_modal_opened',
  BULK_MODAL_CLOSED: 'survey_bulk_modal_closed',
};

export const USER_PROFILE_EVENTS = {
  PAGE_VIEWED: 'user_profile_page_viewed',
  PREFERENCE_CHANGED: 'user_profile_preference_changed',
  PREFERENCES_SAVED: 'user_profile_preferences_saved',
};

export const INFILYTICS_EVENTS = {
  PAGE_VIEWED: 'infilytics_page_viewed',
};

export const ERROR_EVENTS = {
  APP_CRASHED: 'app_crashed',
};

export const LAYOUT_EVENTS = {
  FETCH_SUCCESS: 'layout_fetch_success',
  FETCH_FAILED: 'layout_fetch_failed',
};
